<template>
    <div class="wrapper" v-if="!loading && productsList">

        <div class="comparison__top">

            <div class="comparison__title">
                <h1 class="page-header">Сравнение товаров</h1><a class="more-btn" href="/catalog/">Добавить товары</a>
            </div>

            <div class="comparison__nav">
                <ul class="comparison-tabs">
                    <li v-for="category in categories" @click="setActiveCategory({ value: category.ID})" :class="[activeCategory === category.ID ? 'active' : '']" :key="category.ID" class="comparison-tabs__item">{{ category.NAME }} {{category.items.length}}</li>
                </ul>
                <button @click="clearAll" class="delete">Удалить список</button>
            </div>

        </div>

        <div class="comparison__cont">

            <div class="comparison-tabs__list">
                <div class="comparison-tabs__list-item active" v-if="activeCategory">
                    <div class="compare-slider-wrap">
                        <CompareList v-if="categories" :categoryId="activeCategory"/>
                        <div class="compare-slider__cont compare-slider__cont--left">
                            <template v-if="!isTablet">
                                <Images ref="Images" @next-slide="$refs.Head.nextSlide(), $refs.Desc.nextSlide()" @prev-slide="$refs.Head.prevSlide(), $refs.Desc.prevSlide()" :category-id="activeCategory"/>
                                <Head ref="Head" @next-slide="$refs.Images.nextSlide(), $refs.Desc.nextSlide()" @prev-slide="$refs.Images.prevSlide(), $refs.Desc.prevSlide()" :category-id="activeCategory"/>
                                <Desc ref="Desc" :category-id="activeCategory"/>
                            </template>
                            <template v-else>
                                <ImgSlider ref="imgSlider_1" :category-id="activeCategory"/>
                                <HeadSlider ref="headSlider_1" :category-id="activeCategory"/>
                                <DescSlider ref="descSlider_1" :category-id="activeCategory"/>
                            </template>
                        </div>
                        <div v-if="isTablet" class="compare-slider__cont compare-slider__cont--right">
                            <ImgSlider ref="imgSlider_2" :category-id="activeCategory"/>
                            <HeadSlider ref="headSlider_2" :category-id="activeCategory"/>
                            <DescSlider ref="descSlider_2" :category-id="activeCategory"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ImgSlider from "../components/compareApp/ImgSlider";
import HeadSlider from "../components/compareApp/HeadSlider";
import DescSlider from "../components/compareApp/DescSlider";
import CompareList from "../components/compareApp/CompareList";
import {mapState, mapActions, mapMutations} from "vuex";
import Images from "../components/compareApp/Images";
import Head from "../components/compareApp/Head";
import Desc from "../components/compareApp/Desc";
import oneHeightElements from "../utils/one-height";

export default {
    name: 'comparePage',
    components: {
        Desc,
        Head,
        Images,
        CompareList,
        DescSlider,
        HeadSlider,
        ImgSlider,
    },
    data() {
        return {
            windowWidth: 0,
            isTablet: false,
            loading: false,
        }
    },
    async created() {
        this.loading = true
        await this.loadData()
        this.loading = false
    },
    async mounted() {
        oneHeightElements('.compare-card__top')
        oneHeightElements('.compare-card__design')
        oneHeightElements('.compare-card__list-title')
        oneHeightElements('.compare-card__item-label')
        oneHeightElements('.compare-card__item-text')
        oneHeightElements('.compare-card__item-info')
        oneHeightElements('.compare-card__list .product-docs')
        await this.setWindowWidth()
        window.addEventListener('resize', this.setWindowWidth)
        window.addEventListener('resize', () => {
            oneHeightElements('.compare-card__top')
            oneHeightElements('.compare-card__design')
            oneHeightElements('.compare-card__list-title')
            oneHeightElements('.compare-card__item-label')
            oneHeightElements('.compare-card__item-text')
            oneHeightElements('.compare-card__item-info')
            oneHeightElements('.compare-card__list .product-docs')
        })
    },
    updated() {
        oneHeightElements('.compare-card__top')
        oneHeightElements('.compare-card__design')
        oneHeightElements('.compare-card__list-title')
        oneHeightElements('.compare-card__item-label')
        oneHeightElements('.compare-card__item-text')
        oneHeightElements('.compare-card__item-info')
        oneHeightElements('.compare-card__list .product-docs')
    },
    computed: {
        ...mapState({
            'categories': state => state.categories,
            'productsList': state => state.productsList,
            'activeCategory': state => state.activeCategory
        })
    },
    methods: {
        async loadData() {
            return new Promise(async (resolve) => {
                let cats = await this.loadCategories()
                let prods = await this.loadProducts()
                if (cats && prods) {
                    await this.sortItems()
                }
                resolve()
            })
        },
        setWindowWidth() {
            this.windowWidth = window.innerWidth
            this.isTablet = this.windowWidth <= 1024;
            if (this.isTablet) {
                setTimeout(() => this.setController(), 500)
            }
        },
        setController() {
            let headSwiper
            let imgSwiper
            let descSwiper
            for (let i = 1; i <= 2; i++) {
                headSwiper = this.$refs[`headSlider_${i}`].headSlider
                imgSwiper = this.$refs[`imgSlider_${i}`].imgSlider
                descSwiper = this.$refs[`descSlider_${i}`].descSlider

                headSwiper.controller.control = imgSwiper
                imgSwiper.controller.control = [descSwiper, headSwiper]
                descSwiper.controller.control = imgSwiper
            }
        },
        ...mapActions({
            loadProducts: 'loadProducts',
            loadCategories: 'loadCategories',
            clearAll: 'clearComparsion'
        }),
        ...mapMutations({
            sortItems: 'sortItems',
            setActiveCategory: 'setActiveCategory',
        })
    }
}
</script>

<style lang="css">

</style>
